export function assertNever(value) {
    throw new Error(`Unhandled FilterConfig variant: ${JSON.stringify(value)}`);
}
